import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="#131313"
        stroke-width="13"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M255.459 438.219c-26.581 0-51.926-11.446-69.535-31.404-17.848-20.229-25.806-46.278-22.407-73.349.594-4.731 1.619-9.567 3.047-14.373.779-2.622.45-5.449-.91-7.822l-29.725-51.855a10.003 10.003 0 0 0-13.707-3.669 19.141 19.141 0 0 1-9.614 2.613c-6.879 0-13.296-3.739-16.747-9.757l-29.327-51.134-9.715-16.956 16.805-9.763L191.9 101.971l9.661 16.864 29.319 51.132c5.363 9.351 2.185 21.336-7.083 26.718a10.001 10.001 0 0 0-3.461 13.945l23.495 37.625a10 10 0 0 0 8.779 4.699 57.48 57.48 0 0 1 1.758-.025c1.746 0 3.526.068 5.19.141a10.001 10.001 0 0 0 9.233-5.227l20.786-38.371a10 10 0 0 0-3.827-13.443c-4.461-2.551-7.649-6.682-8.979-11.632-1.344-5.003-.637-10.248 1.99-14.77l29.618-50.959 9.824-16.89 118.793 68.112 16.762 9.6-39.392 67.757c-3.517 6.042-10.044 9.797-17.034 9.797h-.001a19.43 19.43 0 0 1-9.645-2.576 9.996 9.996 0 0 0-13.619 3.649l-29.596 50.905a10.003 10.003 0 0 0-.872 8.094c4.245 13.176 5.522 26.802 3.795 40.499-5.181 41.075-38.75 74.652-79.821 79.838a97.206 97.206 0 0 1-12.114.766zm.001-133.632c-3.081 0-6.199.346-9.267 1.029-15.227 3.39-27.249 15.418-30.627 30.642-2.753 12.404.151 25.104 7.967 34.845 7.813 9.737 19.451 15.322 31.928 15.322 3.04 0 6.118-.337 9.146-1 15.257-3.346 27.32-15.354 30.733-30.596 2.778-12.409-.11-25.123-7.926-34.882-7.815-9.761-19.463-15.36-31.954-15.36zM332.011 66.117l145.784 82.429M178.372 66.117 32.589 148.546"
      />
      <path
        fill="none"
        stroke="#131313"
        stroke-width="13"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M259.857 252.813c42.749 1.73 77.952 32.749 86.085 73.532"
      />
    </svg>
  );
};

export default Icon;
